<template>
  <div>
    <app-header no_back="true" settings="systemZoom">esma</app-header>


    <div class="menu" style="">
      <div class="row" style="margin: 30px;">
        <div class="col-xs-2" style="">
        </div>
        <div class="col-xs-8" >
          <h2 style="text-align: left;">ユーザメニュー</h2>
        </div>
        <div class="col-xs-2" style="">
        </div>
      </div>
      <div class="row" style="margin: 30px;">
        <div class="col-xs-2" style="">
        </div>
        <div class="col-xs-4" style="">

          <router-link v-for="c in col1" :key="c.name"
            :disabled="c.path == '#' || c.disabled" tag="button"
            :to="c.path"
            type="button"
            style="margin: 5px; width: 80%;background: #5a99d2;color: white;font-weight: bold;"
            class="btn btn-primary btn-lg"
            >{{c.name}}</router-link>
        </div>
        <div class="col-xs-4" style="">
          <router-link v-for="c in col2" :key="c.name"
            :disabled="c.path == '#' || c.disabled" tag="button"
            :to="c.path"
            type="button"
            style="margin: 5px; width: 80%;background: #5a99d2;color: white;font-weight: bold;"
            class="btn btn-primary btn-lg"
            >{{c.name}}</router-link>
        </div>
        <div class="col-xs-2" style="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import MenuBtn from "../components/menu-btn";
import { utils } from "@/libs/utils";
import mixinMenuCommon from "@/mixins/mixin_menu_common";


import debug from "debug";
var debug_menu = debug("esma:menu");

Vue.component("menu-btn", MenuBtn);

import { bus } from "@/libs/bus";

export default {
  mixins: [mixinMenuCommon],
  //  name: 'Name here',
  data() {
    return {};
  },
  methods: {},
  computed: {
    col1(){
      return [
        {name:"パスワードの変更",path:"/master_change_password",disabled:this.checkMenuUserPermission(this.acl.master_user_password) == false},
      ]
    },
    col2(){
      return [
        {name:"ユーザ一覧",path:"/master_user",disabled:this.checkMenuUserPermission(this.acl.master_user) == false},
      ]
    }
  },
  created() {},
  mounted() {

      this.$ajax.post('/ping', {}, (err, response) => {
          console.log("Ping response",{err,response})
      })

  },
};
</script>
<style scoped>

.menu {
  text-align: center;
}

.menu-btns {
  text-align: center;
  padding: 0px;
}

.menu-btns-container {
  text-align: center;
  max-width: 1100px;
  margin: auto;
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// menu_master.vue?529f9348